/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AggregationWindow } from '../models';
// @ts-ignore
import type { BillingBalanceResponse } from '../models';
// @ts-ignore
import type { BillingHistoryResponse } from '../models';
// @ts-ignore
import type { BillingTopUpListResponse } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * BillingApi - axios parameter creator
 * @export
 */
export const BillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the current credit balance for the authenticated user\'s organization.
         * @summary Get current billing balance
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceApiV1BillingBalanceGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/billing/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the current credit balance for the authenticated user\'s organization.
         * @summary Get current billing balance
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceApiV1BillingBalanceGet_1: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/billing/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve chartable credit usage history for the authenticated user\'s organization.
         * @summary Get billing usage history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryApiV1BillingHistoryGet: async (startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getHistoryApiV1BillingHistoryGet', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getHistoryApiV1BillingHistoryGet', 'endTime', endTime)
            const localVarPath = `/api/v1/billing/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve chartable credit usage history for the authenticated user\'s organization.
         * @summary Get billing usage history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryApiV1BillingHistoryGet_2: async (startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getHistoryApiV1BillingHistoryGet_2', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getHistoryApiV1BillingHistoryGet_2', 'endTime', endTime)
            const localVarPath = `/api/v1/billing/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the top-up purchase ledger for the authenticated user\'s organization.
         * @summary Get top-up ledger
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopUpsApiV1BillingTopUpsGet: async (startTime?: string | null, endTime?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/billing/top-ups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the top-up purchase ledger for the authenticated user\'s organization.
         * @summary Get top-up ledger
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopUpsApiV1BillingTopUpsGet_3: async (startTime?: string | null, endTime?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/billing/top-ups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingApi - functional programming interface
 * @export
 */
export const BillingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillingApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the current credit balance for the authenticated user\'s organization.
         * @summary Get current billing balance
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalanceApiV1BillingBalanceGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalanceApiV1BillingBalanceGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getBalanceApiV1BillingBalanceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the current credit balance for the authenticated user\'s organization.
         * @summary Get current billing balance
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalanceApiV1BillingBalanceGet_1(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalanceApiV1BillingBalanceGet_1(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getBalanceApiV1BillingBalanceGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve chartable credit usage history for the authenticated user\'s organization.
         * @summary Get billing usage history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoryApiV1BillingHistoryGet(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoryApiV1BillingHistoryGet(startTime, endTime, window, agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getHistoryApiV1BillingHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve chartable credit usage history for the authenticated user\'s organization.
         * @summary Get billing usage history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoryApiV1BillingHistoryGet_2(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoryApiV1BillingHistoryGet_2(startTime, endTime, window, agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getHistoryApiV1BillingHistoryGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the top-up purchase ledger for the authenticated user\'s organization.
         * @summary Get top-up ledger
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopUpsApiV1BillingTopUpsGet(startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingTopUpListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopUpsApiV1BillingTopUpsGet(startTime, endTime, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getTopUpsApiV1BillingTopUpsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the top-up purchase ledger for the authenticated user\'s organization.
         * @summary Get top-up ledger
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopUpsApiV1BillingTopUpsGet_3(startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingTopUpListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopUpsApiV1BillingTopUpsGet_3(startTime, endTime, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getTopUpsApiV1BillingTopUpsGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BillingApi - factory interface
 * @export
 */
export const BillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillingApiFp(configuration)
    return {
        /**
         * Retrieve the current credit balance for the authenticated user\'s organization.
         * @summary Get current billing balance
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceApiV1BillingBalanceGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingBalanceResponse> {
            return localVarFp.getBalanceApiV1BillingBalanceGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the current credit balance for the authenticated user\'s organization.
         * @summary Get current billing balance
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceApiV1BillingBalanceGet_1(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingBalanceResponse> {
            return localVarFp.getBalanceApiV1BillingBalanceGet_1(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve chartable credit usage history for the authenticated user\'s organization.
         * @summary Get billing usage history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryApiV1BillingHistoryGet(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingHistoryResponse> {
            return localVarFp.getHistoryApiV1BillingHistoryGet(startTime, endTime, window, agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve chartable credit usage history for the authenticated user\'s organization.
         * @summary Get billing usage history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryApiV1BillingHistoryGet_2(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingHistoryResponse> {
            return localVarFp.getHistoryApiV1BillingHistoryGet_2(startTime, endTime, window, agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the top-up purchase ledger for the authenticated user\'s organization.
         * @summary Get top-up ledger
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopUpsApiV1BillingTopUpsGet(startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingTopUpListResponse> {
            return localVarFp.getTopUpsApiV1BillingTopUpsGet(startTime, endTime, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the top-up purchase ledger for the authenticated user\'s organization.
         * @summary Get top-up ledger
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopUpsApiV1BillingTopUpsGet_3(startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingTopUpListResponse> {
            return localVarFp.getTopUpsApiV1BillingTopUpsGet_3(startTime, endTime, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
export class BillingApi extends BaseAPI {
    /**
     * Retrieve the current credit balance for the authenticated user\'s organization.
     * @summary Get current billing balance
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getBalanceApiV1BillingBalanceGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getBalanceApiV1BillingBalanceGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the current credit balance for the authenticated user\'s organization.
     * @summary Get current billing balance
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getBalanceApiV1BillingBalanceGet_1(authorization?: string, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getBalanceApiV1BillingBalanceGet_1(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve chartable credit usage history for the authenticated user\'s organization.
     * @summary Get billing usage history
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {AggregationWindow} [window] Aggregation window for history buckets
     * @param {string | null} [agentId] Optional agent filter
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getHistoryApiV1BillingHistoryGet(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getHistoryApiV1BillingHistoryGet(startTime, endTime, window, agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve chartable credit usage history for the authenticated user\'s organization.
     * @summary Get billing usage history
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {AggregationWindow} [window] Aggregation window for history buckets
     * @param {string | null} [agentId] Optional agent filter
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getHistoryApiV1BillingHistoryGet_2(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getHistoryApiV1BillingHistoryGet_2(startTime, endTime, window, agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the top-up purchase ledger for the authenticated user\'s organization.
     * @summary Get top-up ledger
     * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
     * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getTopUpsApiV1BillingTopUpsGet(startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getTopUpsApiV1BillingTopUpsGet(startTime, endTime, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the top-up purchase ledger for the authenticated user\'s organization.
     * @summary Get top-up ledger
     * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
     * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getTopUpsApiV1BillingTopUpsGet_3(startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getTopUpsApiV1BillingTopUpsGet_3(startTime, endTime, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

